import { Checkbox, FormControlLabel } from '@mui/material';

import { LabelCheckboxProps } from './props';

export const LabelCheckbox = ({
  checkboxProps,
  ...props
}: LabelCheckboxProps) => {
  return (
    <FormControlLabel
      sx={{
        alignItems: 'center',
        display: 'flex',
      }}
      {...props}
      control={<Checkbox sx={{ marginLeft: '-11px' }} {...checkboxProps} />}
    />
  );
};

export default LabelCheckbox;
